import { message } from 'antd';

export const openMiniPage = async (accId, path, params) => {
  
    let newWindow = window.open('', '_blank');
    // console.log('shopId', currentShopId);

    const response = await fetch(`/api/wxopen/wx-mini-page-url`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            accId,
            path,
            params,
        })
    });
    const result = await response.json();

    if(result.success) {
        if(newWindow) {
            newWindow.location.href = result.data.url_link;
        }
    } else {
        if(newWindow) {
            newWindow.close();
        }
        message.error(result.data);
    }
}